import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../../user/providers/UserPhoneVerificationProvider";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
}

export const PromotionLeadPhoneVerification = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber} = props;

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase isOpen={isOpen} onClose={onClose} onSuccess={onSuccess} onChangeNumber={onChangeNumber} />
        </UserPhoneVerificationProvider>
    );
};
import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../../user/providers/UserPhoneVerificationProvider";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
}

export const PromotionLeadPhoneVerification = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber} = props;

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase isOpen={isOpen} onClose={onClose} onSuccess={onSuccess} onChangeNumber={onChangeNumber} />
        </UserPhoneVerificationProvider>
    );
};
